let TimeModeActivityLogic = xClass("TimeModeActivityLogic")
let TimeModeActivityPanel = require("activity/TimeModeActivity/TimeModeActivityPanel")
// require("activity/TimeModeActivity/TimeModeActivityManager")

let ShareUtil = require("clover/utils/ShareUtil")

let _instance = null
TimeModeActivityLogic.getInstance = function () {
    if (!_instance) {
        _instance = TimeModeActivityLogic.create()
    }
    return _instance
}
TimeModeActivityLogic.prototype.ctor = function () {
}
TimeModeActivityLogic.prototype.isActivityOpen = function () {
    return UserManager.getInstance().isTimeModeActivityOpen()
}
// TimeModeActivityLogic.prototype.showIcon = function () {
//     let self = this
//     let icon = require("./TimeModeActivityIcon").create()
//     let homeScene = require("clover/scene/HomeScene").getInstance()
//     if (homeScene.btnLayer && !homeScene.btnLayer.TimeModeIcon) {
//         homeScene.btnLayer.TimeModeIcon = icon
//         icon.posIndex = 4
//         homeScene.btnLayer.addBtnToSelf(icon, ICON_TYPE.kLeft)
//     }
//     self.icon = icon
// }
// TimeModeActivityLogic.prototype.updateIcon = function () {
//     let self = this
//     self.icon && self.icon.update()
// }
TimeModeActivityLogic.prototype.showPanel = function (helpData, callback) {
    let self = this
    if (self.isBusy) {
        return
    }
    self.isBusy = true
    function sendHelpHttp() {
        if (helpData && helpData.shareId && helpData.nickname && helpData.uid) {
            self.helpFriendGetTimes(helpData.shareId, helpData.nickname, helpData.uid)
        }
    }
    function onFinish() {
        self.isBusy = false
        callback && callback()
    }
    function allOp() {
        sendHelpHttp()
        onFinish()
    }
    Promise.all([
        TimeModeActivityManager.getInstance().loadDataFromServer(true),
        TimeModeActivityManager.getInstance().loadDataFromConfig(),
        TimeModeActivityPanel.load(),
    ]).then(() => {
        let panel = TimeModeActivityPanel.create(self, onFinish)
        panel.popup(true)
        sendHelpHttp()
        // self.icon && self.icon.update()
        TimeModeActivityManager.getInstance().updateIcon()
    }).catch((data) => {
        Toast.make(curryQuickGetErrorText( data || 0))
        allOp()
    })
    //  处理上一次未成功结算的记录
    TimeModeActivityManager.getInstance().dealLastLevelRecord()
}
TimeModeActivityLogic.prototype.helpFriendGetTimes = function (shareId, name, uid) {
    name = name || ""
    let http = TimeModeHelpAddTimesHttp.new()
    http.addEventListener(Events.kComplete, () => {
        Toast.make(getText("time.match.getreward"))
    })
    http.addEventListener(Events.kError, (evt = {}) => {
        Toast.make(quickGetErrorText(evt.retCode, "帮助好友成功！"))
    })
    http.load(uid, shareId)
}

TimeModeActivityLogic.prototype.shareNoTimes = function(onSuccess, onFail, onCancel) {
    let http = TimeModeGetShareIdHttp.new()
    function success(evt) {        
        ShareUtil.clickTimeModeAskHelp(
            evt.data.shareId, 
            onSuccess,
            ()=> Toast.make(getText("activity.sharefailed"), 1, onFail), 
            ()=> Toast.make(getText("activity.sharefailed"), 1, onCancel));
    }

    http.addEventListener(Events.kComplete, success);
    http.addEventListener(Events.kError, evt => {
        Toast.make(curryQuickGetErrorText(evt.data), 1, onFail);
    });
    http.addEventListener(Events.kCancel, () => {
        Toast.make(getText("activity.sharefailed"), 1, onCancel)
    });
    http.load();
}
module.exports = TimeModeActivityLogic